import { UnicodeEntity } from '@mews/enums';
import { ContentSection, SubContentSection } from '@mews-commander/ui';
import { LocalizedEnum, lt } from '@mews/framework';
import { RateGroupOptions } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';

export interface SettlementConfigurationSectionProps {
    settlementMaximumTimeUnits?: number | null;
    settlementExtent: Array<'TimeUnits' | 'Products' | 'AdditionalExpenses'>;
    options: Array<'AutomaticDepositSettlement' | 'CreateSettlementTask'>;
}

export const SettlementConfigurationSection = ({
    settlementMaximumTimeUnits,
    settlementExtent,
    options,
}: SettlementConfigurationSectionProps) => (
    <ContentSection title={lt('CentralRateGroupEditConfigurationSectionTitle')}>
        <SubContentSection title={lt('PaymentMaximumTime')}>
            {settlementMaximumTimeUnits ?? UnicodeEntity.Dash}
        </SubContentSection>
        <SubContentSection title={lt('SettlementExtent')}>
            {settlementExtent.map((extent, index) => (
                <span key={extent}>
                    {/* @ts-expect-error error because we're decoupling these components from enums and using string literals */}
                    <LocalizedEnum prefix="SettlementExtent" value={extent} />
                    {index < settlementExtent.length - 1 && UnicodeEntity.Comma}
                </span>
            ))}
        </SubContentSection>
        <SubContentSection title={lt('Options')}>
            {options.length > 0
                ? options.map((option, index) => (
                      <span key={option}>
                          {lt(rateGroupOptions[option])}
                          {index < options.length - 1 && UnicodeEntity.Comma}
                      </span>
                  ))
                : UnicodeEntity.Dash}
        </SubContentSection>
    </ContentSection>
);

const rateGroupOptions = {
    [RateGroupOptions.AutomaticDepositSettlement]: TextKey.RateGroupOptionsAutomaticTaxDeposit,
    [RateGroupOptions.CreateSettlementTask]: TextKey.RateGroupOptionsCreatePaymentTask,
};
